import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useStore } from '../../../../../app/data/root.store';
import { VaultUploadIcon } from '../../../../../vault/assets/icons';
import { VaultBulkEditRow } from '../../../../../vault/component/VaultBulkEdit/VaultBulkEditRow';
import { VaultFilters } from '../../../../../vault/component/VaultFilters/VaultFilters';
import { VaultButtonBlack } from '../../../../../vault/component/VaultHeader/VaultHeader.styles';
import { VaultList } from '../../../../../vault/component/VaultList/VaultList';
import { VaultMetadataPanel } from '../../../../../vault/component/VaultMetadataPanel/VaultMetadataPanel';
import { VaultModals } from '../../../../../vault/component/VaultModals/VaultModals';
import { VaultSearch } from '../../../../../vault/component/VaultSearch/VaultSearch';
import { VaultUpload } from '../../../../../vault/component/VaultUpload/VaultUpload';
import { AssetVaultTabContent, AssetVaultTabHeader, AssetVaultTabWrapper, VaultSearchAndFiltersWrapper } from './AssetVaultTab.styles';
import { MobileAssetVaultTab } from './MobileAssetVaultTab';

export const AssetVaultTab = observer(() => {
  const { uiStore } = useStore();

  return (
    <div className="asset-vault-tab-wrapper">
      {uiStore.isDesktopView ? <AssetVaultTabDesktop /> : <MobileAssetVaultTab />}
    </div>
  );
});

export const AssetVaultTabDesktop = observer(() => {
  const { vaultStore } = useStore();
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const isMetadataPanelOpen = vaultStore.isMetadataPanelOpen;

  return (
    <>
      <AssetVaultTabWrapper>
        <AssetVaultTabHeader>
          <VaultSearchAndFiltersWrapper>
            <VaultSearch />
            <VaultFilters />
          </VaultSearchAndFiltersWrapper>
          <VaultButtonBlack onClick={() => setIsUploadModalOpen(true)}>
            <VaultUploadIcon />
            <div>Upload files</div>
          </VaultButtonBlack>
        </AssetVaultTabHeader>
        <AssetVaultTabContent>
          <VaultList />
        </AssetVaultTabContent>
        {isUploadModalOpen && <VaultUpload onClose={() => setIsUploadModalOpen(false)} />}
        {isMetadataPanelOpen && <VaultMetadataPanel />}
      </AssetVaultTabWrapper>
      <VaultModals />
      {vaultStore.isBulkEditMode && vaultStore.selectedFilesForBulkEdit.length > 0 &&
        <VaultBulkEditRow isSticky={true} />}
    </>
  );
}); 